import React, { useState } from "react";


import { EllipsisVertical, MenuIcon } from "lucide-react";
import { Dropdown } from "react-bootstrap";

import { useDispatch, useSelector } from "react-redux";
import { ReactSVG } from "react-svg";

import { ObjectiveDetailsSlidingPanel } from "../SlidingPanel/ObjectiveDetailsSlidingPanel";
import { BoldText, LightText, NormalText, PrimarySmallNormalText, SmallLightText, SmallNormalText } from "../../../../../utils/typographyUtils";
import ButtonIcon from "../../../../shared/formComponents/StandardButton/ButtonIcon";
import StandardButton from "../../../../shared/formComponents/StandardButton/StandardButton";
import { StandardTooltip } from "../../../../shared/StandardTooltip/StandardTooltip";
import { getProgressBarColour } from "../../../../../utils/generalUtils";
import { KeyResultsAccordion } from "../KeyResultsAccordion/KeyResultsAccordion";
import { InitiativesAccordion } from "../InitiativesAccordion/InitiativesAccordion";
import { ConditionalRender } from "../../../../shared/ConditionalRender/ConditionalRender";


export const PublishedPlanObjectiveAccordionItem = ({
  objective,
  isExpanded,
  onHeaderClick,
  buttonDisabled,
  callBack,
  isLastObjective,
  editMode,
  showConfirmationButtons,
  handleDeleteBusinessPlanObjective,
  setShowDeleteObjectivePopup,
  showDeleteObjectivePopup,
  isViewMode,
  handleUpdateBusinessPlanObjective,
  businessPlanId,
  expandedKeyResult,
  expandedObjective,
  isPlanPublished,
  setShowConfirmationButtons,
  closeAllAccordions,
  showActions
}) => {
  const dispatch = useDispatch();
  const [originalObjective, setOriginalObjective] = useState(
    objective.description,
  );
  const [showObjectiveDetailsPanel, setShowObjectiveDetailsPanel] =
    useState(false);

  const userProfile = useSelector((state) => state.authDetails.userProfile);
  const isBIPLeader = useSelector((state) => state.authDetails.isBIPLeader);
  const [showAddKeyResultField, setShowAddKeyResultField] = useState(false);
  const [showDeleteKeyResultPopup, setShowDeleteKeyResultPopup] =
    useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showChangeOwnerPopup, setShowChangeOwnerPopup] = useState(false);
  const [ownerName, setOwnerName] = useState("");
  const handleUpdateValue = (value) => {
    setOriginalObjective(value);
  };

  const handleDisableOperations = () => {
    let isOwner = userProfile.id === objective.ownerId;
    const isAllowed = isBIPLeader || (isPlanPublished && isOwner);
    return isViewMode || !isAllowed;
  };

  const renderObjectiveActionsDropdown = () => {
    if (!showActions) {
      return null;
    }
    return (
      <Dropdown onClick={(e) => e.stopPropagation()} id="objective-dropdown">
        <Dropdown.Toggle>
          <LightText classNames={`cursor-pointer`}>
            <ButtonIcon icon={EllipsisVertical} />
          </LightText>
        </Dropdown.Toggle>
        <Dropdown.Menu id="dropdown-basic" className="qrap-dropdown-menu">
          <Dropdown.Item
            disabled={true}
          >
            Edit Objective
          </Dropdown.Item>
          {isLastObjective ? (
            <Dropdown.Item disabled={true}>
              <SmallLightText>
                Can't delete — at least one objective required
              </SmallLightText>
            </Dropdown.Item>
          ) : (
            <Dropdown.Item
            disabled={true}              
            >
              Delete Objective
            </Dropdown.Item>
          )}
          <Dropdown.Item disabled={true}>
            Change Owner
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  const handleShowObjectiveButtons = () => {
    return (
      <div className="d-flex py-2 align-items-center">
        <ReactSVG
          src="/assets/images/light_close_icon.svg"
          className="ms-3 cursor-pointer"
          onClick={(e) => {
            e.stopPropagation();
            setShowConfirmationButtons({ show: false, type: "" });
          }}
        />
        <StandardButton
          className="ms-2 py-1"
          color="btn-brand-blue-new"
          isLoading={buttonDisabled}
          disabled={true}
          text="Save"
          darkLoader={true}
          onClick={(e) => {
          }}
        />
      </div>
    );
  };
  return (
    <div className="border cs-br-8 my-3 published-plan-objective-accordion-item">
      {/* HEADER */}
      <div
        onClick={() => onHeaderClick()}
        className="d-flex align-items-start p-3 cursor-pointer published-plan-objective-accordion-item-header align-items-stretch"
      >
        <div
          className={`${showConfirmationButtons.type === "update" &&
            showConfirmationButtons.id === objective.businessPlanObjectiveId
            ? "mt-2"
            : ""
            }`}
        >
          <img src="/assets/images/objectives.svg" />
          <BoldText classNames={"ms-3 light-text"}>Objective</BoldText>
        </div>
        <div className="d-flex flex-column ms-3 align-items-start w-75">
          <NormalText classNames={"objective-div"}>
            {objective.description}
          </NormalText>
          <div className="mt-3 d-flex align-items-center justify-content-start">
            <div className="me-2 name-initial-div">
              {objective.ownerName.charAt(0)}
            </div>
            <SmallNormalText>{objective.ownerName}</SmallNormalText>
            <div className="d-flex align-items-center">
              <StandardTooltip
                placement="top"
                tooltTipContent={
                  "Objective progress is auto calculated based on the average of initiative progress"
                }
              >
                <div className="ms-5 progress-bar-div">
                  <div
                    className="progress-bar-fill"
                    style={{
                      width: `${objective.totalProgressPercentage}%`,
                      backgroundColor: getProgressBarColour(
                        objective.totalProgressPercentage,
                      ),
                      height: "100%",
                    }}
                  ></div>
                </div>
              </StandardTooltip>
              <SmallLightText classNames={"ms-2"}>
                {Math.floor(objective.totalProgressPercentage)}%
              </SmallLightText>
            </div>
          </div>
        </div>
        <div className="ms-auto d-flex flex-column justify-content-between align-items-end">
          <div className="d-flex align-items-center">
            {renderObjectiveActionsDropdown()}
            <div className="ms-3 published-plan-objective-accordion-header-arrow">
              <img
                onClick={(e) => {
                  e.stopPropagation();
                  onHeaderClick();
                }}
                className="cursor-pointer"
                src={`/assets/images/${isExpanded ? "up-arrow.svg" : "down-arrow.svg"}`}
              />
            </div>
          </div>
          <PrimarySmallNormalText
            onClick={(e) => {
              e.stopPropagation();
              setShowObjectiveDetailsPanel(true);
            }}
            classNames={"cursor-pointer mt-3 text-decoration-underline"}
          >
            View Details
          </PrimarySmallNormalText>
        </div>
      </div>
      {/* CONTENT */}
      <div
        className={`published-plan-objective-accordion-body ${isExpanded ? "open" : ""}`}
      >
        <KeyResultsAccordion
          isExpanded={isExpanded}
          callBack={callBack}
          isViewMode={isViewMode}
          data={objective.keyResults}
          disableOperations={handleDisableOperations()}
          isOwner={userProfile.id === objective.ownerId}
          editMode={editMode && userProfile.id === objective.ownerId}
          expandedKeyResult={expandedKeyResult}
          expandedObjective={expandedObjective}
          objectiveId={objective.businessPlanObjectiveId}
          showAddKeyResultField={showAddKeyResultField}
          setShowAddKeyResultField={setShowAddKeyResultField}
          setShowDeleteKeyResultPopup={setShowDeleteKeyResultPopup}
          showDeleteKeyResultPopup={showDeleteKeyResultPopup}
          isPlanPublished={true}
          closeAllAccordions={closeAllAccordions}
          showActions={showActions}
        />
        <InitiativesAccordion
          isViewMode={isViewMode}
          disableProgress={!isPlanPublished}
          initiatives={objective.initiatives}
          callBack={callBack}
          isOwner={userProfile.id === objective.ownerId}
          editMode={editMode}
          disableOperations={handleDisableOperations()}
          expandedObjective={expandedObjective}
          objectiveId={objective.businessPlanObjectiveId}
          isPlanPublished={true}
          closeAllAccordions={closeAllAccordions}
          showActions={showActions}
        />
      </div>
      <ConditionalRender condition={showObjectiveDetailsPanel}>
        <ObjectiveDetailsSlidingPanel
          isOpen={showObjectiveDetailsPanel}
          objectiveId={objective.businessPlanObjectiveId}
          onClose={() => setShowObjectiveDetailsPanel(false)}
        />
      </ConditionalRender>
    </div>

  );
};
